import { render, staticRenderFns } from "./StatisticsOverview.vue?vue&type=template&id=64155dcc&scoped=true&"
import script from "./StatisticsOverview.vue?vue&type=script&lang=ts&"
export * from "./StatisticsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64155dcc",
  null
  
)

export default component.exports